import { pushNotification } from '../../../utils/notifications';
import React, { useEffect, useMemo, useCallback, useState } from "react";
import ReactDropdown from "react-dropdown";
import "react-dropdown/style.css";
import userApi from "../../../service/userApi";
import Modal from "react-bootstrap/Modal";

export const SearchBarDesktop = ({ dataSearch, setDataSearch, onSearch }) => {
    const [listCreateUser, setListCreateUser] = useState([]);
    const [showModal, setShowModal] = useState(false);

    useEffect(() => {
        userApi.combo2()
            .then(res => {
                if (res && res.status === 200) {
                    const allOption = { label: 'Tất cả', value: 0 };
                    const userList = res.data || [];
                    setListCreateUser([allOption, ...userList]);
                } else {
                    pushNotification("Lấy danh sách người tạo thất bại!", "error", "TOP_CENTER", 2000);
                }
            })
            .catch((error) => {
                console.error("Lỗi khi gọi API getListCreateUser:", error);
                pushNotification("Lấy danh sách người tạo thất bại!", "error", "TOP_CENTER", 2000);
            });
    }, []);

    const selectedCreateUserOption = useMemo(() => {
        const selectedValue = dataSearch.sCreatedUser ?? 0;
        return listCreateUser.find(opt => opt.value === selectedValue) || listCreateUser[0];
    }, [listCreateUser, dataSearch.sCreatedUser]);

    const toggleModal = () => setShowModal(!showModal);

    const handleSearch = useCallback((e) => {
        if (e) e.preventDefault();
        setDataSearch(prev => ({ ...prev, iPageIndex: 1 }));
        onSearch({ ...dataSearch, iPageIndex: 1 });
        if (showModal) setShowModal(false);
    }, [setDataSearch, onSearch, dataSearch, showModal]);

    const handleTextChange = (field) => (e) => {
        let value = '';
        if (e && e.target && typeof e.target.value !== 'undefined') {
            value = e.target.value;
        }
        setDataSearch(prev => ({ ...prev, [field]: value }));
    };

    const handleDropdownChange = (field) => (option) => {
        if (option && typeof option.value !== 'undefined') {
            setDataSearch(prev => ({ ...prev, [field]: option.value, iPageIndex: 1 }));
        }
    };

    const handleKeyDown = (event) => {
        if (event.key === "Enter") {
            handleSearch(event);
        }
    };

    const renderFormFields = () => (
        <>
            <div className="input-sm-new input-new-18">
                <label className="font-color-default font-bold">Tên loại phiếu</label>
                <input
                    type="text"
                    className="form-control input-sm"
                    placeholder="Nhập tên loại phiếu"
                    value={dataSearch.sSearch || ""}
                    onChange={handleTextChange("sSearch")}
                    onKeyDown={handleKeyDown}
                />
            </div>
            <div className="input-sm-new input-new-18">
                <label className="font-color-default font-bold">Người tạo</label>
                <ReactDropdown
                    options={listCreateUser}
                    onChange={handleDropdownChange("sCreatedUser")}
                    value={selectedCreateUserOption}
                    placeholder="Tất cả"
                    controlClassName="form-control input-sm"
                />
            </div>
        </>
    );

    return (
        <>
            <div className="card border-light hidden-mobile-main show-table-main card-v2" style={{ marginTop: "-8px" }}>
                <div className="card-body card-body-v2">
                    <div className="search-new ban-hang-search-form">
                        
                        {renderFormFields()}
                        
                        <div className="input-sm-new input-new-18 search-main-new">
                            <button
                                type="button"
                                className="btn btn-info-new"
                                style={{ marginTop: "25px", paddingTop: "7px" }}
                                onClick={handleSearch}
                            >
                                <i className="la la-search"></i>
                                <span> &nbsp; Tìm kiếm</span>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <div className="repeater-default hide-table-main show-mobile-main hidden-des-main">
                <div className="col-sm-12">
                    <div className="form row">
                        <div className="col-12">
                            <button
                                type="button"
                                className="btn btn-info-new"
                                onClick={toggleModal}
                            >
                                Tìm kiếm <i className="la la-search"></i>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <Modal
                show={showModal}
                onHide={toggleModal}
                dialogClassName="modal-lg"
                className="modal-new modal fade text-left"
                backdrop="static"
            >
                <Modal.Header>
                    <h2 className="modal-title p-1">
                        Tìm kiếm
                    </h2>
                    <button type="button" className="close-popup-new" onClick={toggleModal}>
                        <img src="/app-assets/images/icon-dong-popup-v2.png" alt="close" />
                    </button>
                </Modal.Header>
                <Modal.Body>
                    <div>
                        {renderFormFields()}
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <button
                        type="button"
                        className="btn btn-info"
                        onClick={handleSearch}
                    >
                        <i className="fas fa-search"></i> Tìm kiếm
                    </button>
                    <button type="button" className="btn btn-info" onClick={toggleModal}>
                        <i className="fas fa-times"></i> Đóng
                    </button>
                </Modal.Footer>
            </Modal>
        </>
    );
};